module.exports = __webpack_public_path__ + "static/media/madonna-with-child.7562fb02.jpg";